import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Hero = ({ t }) => {
  const scrollToContact = () => {
    document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToPortfolio = () => {
    document.querySelector("#portfolio")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="hero-bg min-h-screen flex items-center relative overflow-hidden">
      <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,rgba(197,160,89,0.1)_0%,transparent_70%)] pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-32 md:py-40 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          <div className="space-y-8">
            <div className="opacity-0 animate-fade-in-up">
              <span className="text-sm tracking-[0.2em] uppercase text-[#C5A059]">
                {t.hero.badge}
              </span>
            </div>

            <h1 data-testid="hero-title" className="text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight leading-[1.1] opacity-0 animate-fade-in-up delay-100" style={{ fontFamily: "'Playfair Display', serif" }}>
              <span className="text-[#E5E5E5]">The</span>{" "}
              <span className="text-gold-gradient">Medical</span>
              <br />
              <span className="text-[#E5E5E5]">Architect</span>
            </h1>

            <p data-testid="hero-subtitle" className="text-lg md:text-xl text-[#A3A3A3] leading-relaxed max-w-lg opacity-0 animate-fade-in-up delay-200">
              {t.hero.subtitle}
              <span className="block mt-2 text-[#E5E5E5]">{t.hero.subtitle2}</span>
            </p>

            <div className="space-y-3 opacity-0 animate-fade-in-up delay-300">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 border border-[#C5A059]/50 flex items-center justify-center">
                  <Check className="w-3 h-3 text-[#C5A059]" />
                </div>
                <span className="text-[#A3A3A3] text-sm">{t.hero.features[0]}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 border border-[#C5A059]/50 flex items-center justify-center">
                  <Check className="w-3 h-3 text-[#C5A059]" />
                </div>
                <span className="text-[#A3A3A3] text-sm">{t.hero.features[1]}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 border border-[#C5A059]/50 flex items-center justify-center">
                  <Check className="w-3 h-3 text-[#C5A059]" />
                </div>
                <span className="text-[#A3A3A3] text-sm">{t.hero.features[2]}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 border border-[#C5A059]/50 flex items-center justify-center">
                  <Check className="w-3 h-3 text-[#C5A059]" />
                </div>
                <span className="text-[#A3A3A3] text-sm">{t.hero.features[3]}</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in-up delay-400">
              <Button onClick={scrollToContact} data-testid="hero-cta-primary" className="btn-gold bg-[#C5A059] text-[#050505] hover:bg-[#D4B068] px-8 py-6 text-base tracking-widest uppercase font-medium group">
                {t.hero.ctaPrimary}
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
              <Button onClick={scrollToPortfolio} data-testid="hero-cta-secondary" variant="outline" className="border-white/10 text-[#E5E5E5] hover:bg-white/5 hover:border-[#C5A059]/30 px-8 py-6 text-base tracking-widest uppercase">
                {t.hero.ctaSecondary}
              </Button>
            </div>
          </div>

          <div className="relative hidden lg:block opacity-0 animate-fade-in delay-300">
            <div className="relative">
              <div className="relative overflow-hidden">
                <img src="https://images.unsplash.com/photo-1642844819197-5f5f21b89ff8?w=800&q=80" alt="Consultório médico moderno e premium - The Medical Architect cria websites para médicos em Portugal" className="w-full h-[600px] object-cover image-mask" data-testid="hero-image" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
              </div>
              <div className="absolute bottom-12 left-0 glass-card px-6 py-4 animate-float">
                <p className="text-xs tracking-widest uppercase text-[#C5A059] mb-1">{t.hero.priceFrom}</p>
                <p className="text-2xl font-medium text-[#E5E5E5]" style={{ fontFamily: "'Playfair Display', serif" }}>€1200</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 opacity-0 animate-fade-in delay-500">
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs tracking-widest uppercase text-[#A3A3A3]">Scroll</span>
          <div className="w-px h-8 bg-gradient-to-b from-[#C5A059] to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
